<template>
  <div
    class="form-group"
    v-if="as != 'checkbox' && as != 'radio'"
    :class="{
      'has-error': errors[title] != undefined,
      focused: modelValue != null && modelValue.toString() != '' ? true : false,
      buttons: buttons == true,
      checkDisabled: checkDisabled == true,
    }"
  >
    <div class="checkDisabled" v-if="checkDisabled == true">
      <slot name="checkDisabled"></slot>
    </div>
    <Field
      :type="type == undefined ? 'text' : type"
      :as="as"
      v-if="as != 'select'"
      v-maska="maska"
      v-bind="$attrs"
      :id="uid"
      :name="title"
      class="form-control"
      :class="{ 'parsley-error': errors[title] != undefined }"
      v-model="model"
      :autocomplete="'new-'+(type == undefined ? 'text' : type)"
      @input="$emit('update:modelValue', $event.target.value)"
      :rules="rules"
    />
    <Field
      :type="type == undefined ? 'text' : type"
      :as="as"
      v-if="as == 'select'"
      v-maska="maska"
      v-bind="$attrs"
      :id="uid"
      :name="title"
      class="form-control"
      :class="{ 'parsley-error': errors[title] != undefined }"
      v-model="model"
      :autocomplete="'new-'+(type == undefined ? 'text' : type)"
      @input="$emit('update:modelValue', $event.target.value)"
      :rules="rules"
    >
      <slot name="input"></slot>
    </Field>
    <label class="control-label" :for="uid">{{ title }} </label>
    <slot name="buttons"></slot>
    <ErrorMessage as="span" class="form-control-feedback small" :name="title" />
  </div>

  <div class="myCheckBox" v-if="as == 'checkbox'">
    <input
      :type="as"
      class="filled-in"
      :id="uid"
      v-bind="$attrs"
      :checked="modelValue"
      @input="$emit('update:modelValue', $event.target.checked)"
      :rules="rules"
    />
    <label :for="uid" v-bind="$attrs">{{ title }}</label>
  </div>
</template>

<script>
// import searchSelectBox from "./searchSelectBox.vue";
export default {
  name: "formGroup",
  props: [
    "errors",
    "title",
    "modelValue",
    "rules",
    "type",
    "as",
    "buttons",
    "checkDisabled",
    "maska",
  ],
  // components:{searchSelectBox},
  data() {
    return {
      uid: this.$uniqueid(),
      test: "",
      model: this.modelValue,
    };
  },
  watch: {
    modelValue() {
      this.model = this.modelValue;
    },
  },
  methods: {
    log(val) {
      console.log(val);
    },
  },
};
</script>

<style scoped></style>
